import React, { Component } from 'react';
import InventoryFile from './InventoryFile.js';
import {Tabs, Tab, Spinner} from 'react-bootstrap';
import { connect } from 'react-redux';
import { InventoryMaster,InventoryMasterDataUpdate, InventoryMasterAddData,InventoryMasterDataEdit,
	InventoryMasterDataMapping, closeModalPopUp, InventoryAction} from './InventoryAction.js';	
import ShowModalPopUp from '../ShowModalPopUp';
import _ from 'lodash';
import InventoryFileMapping from './InventoryFileMapping';
import InventoryMappedList from './InventoryMappedList';

 class Inventory extends Component { 
	constructor(props){
		super(props)
		this.state={
		}
	}
	
	loadTabContent = (prop) => {
    this.setState({key:prop})
	}
	ScreensComp = () =>{        
		const{masterinventory, inventory, loginAction} = this.props
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
		let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "INVENTORY_MANAGEMENT"})
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "HOME"){ 
          returnObj.push(<Tab eventKey="HOME" title="CREATE" key={1}>	
		 <InventoryFile action={this.props} masterinventory={masterinventory} /></Tab>)}
        if(obj.screenUId === "MAPPING"){ 
          returnObj.push(<Tab eventKey="MAPPING" title="MAPPING" key={2}>
			<InventoryFileMapping action={this.props} masterinventory={masterinventory} /></Tab>)}
				if(obj.screenUId === "MAPPED_LIST"){ 
          returnObj.push(	<Tab eventKey="MAPPED_LIST" title="MAPPED LIST" key={3}>	
			<InventoryMappedList	action={this.props} inventory={inventory} />
				</Tab>)}
		})
		returnObj =	_.sortBy(returnObj, ['key'])
   return (<Tabs defaultActiveKey={moduleAccess.screens[0].screenUId} transition={false} activeKey={key ? key : returnObj[0].props.eventKey} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
    }
     
  } 
	render(){
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
		}
		
		return(
			<div  className={(style) ? 'user' : "userSmall"}>
				{this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
				{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
				falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
				{this.ScreensComp()}	
			</div>)
	}


}
function mapStateToProps(state){
  return{
		masterinventory: state.InventoryReducer.master,
		size: state.UserReducer.large,
		showerror:  state.InventoryReducer.showerror, 
		errmessage:  state.InventoryReducer.errmessage,
		inventory: state.InventoryReducer.result,		
		isPending: state.InventoryReducer.isPending,	
		loginAction: state.LoginReducer.loginAction,
		showModalLogin: state.UserReducer.showModalLogin,
  }  
}

const mapDispatchToProps = (dispatch) => ({
	actioninventoryMaster: () => dispatch(InventoryMaster()),
	actioninventoryMasteraddData: (a,b, c) => dispatch(InventoryMasterAddData(a,b,c)),
	actioninventoryMasterUpdate: (a,b, c, d, e) => dispatch(InventoryMasterDataUpdate(a,b,c, d, e)),
	actioninventoryMasterEdit: (a,b, c, d) => dispatch(InventoryMasterDataEdit(a,b,c, d)),
	actioninventoryMapping: (a) => dispatch(InventoryMasterDataMapping(a)),
	actioninventory: (a) => dispatch(InventoryAction()),
	closeModalPopUp:  (a) =>dispatch(closeModalPopUp(a)), 
})


export default connect(mapStateToProps, mapDispatchToProps)(Inventory);